<template>
  <div class="viewReply">
    <el-dialog title="" :visible.sync="viewReplyVisible" center :before-close="handleClose">
      <p class="reply">{{formInfo.replyTitle}}</p>
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="140px" class="replyCodeForm" v-if="replyAnswer == 1">
        <el-form-item prop="code" :label="formInfo.replyCode">
          <el-input v-model="form.code" :placeholder="formInfo.replyCodePlaceholder"></el-input>
        </el-form-item>
      </el-form>
      <div v-if="replyAnswer == 2">
        <div class="QAMain">
          <el-row class="bg">
            <el-col :xs="24" :sm="7" :md="5" style="border-right:1px solid #ccc;min-height:81px;">
              <p>
                <span class="title">{{data.categoryName}}</span>
                <span>{{data.name}}</span>
              </p>
              <p>{{data.createdAt|dateFormat}}</p>
            </el-col>
            <el-col :xs="24" :sm="17" :md="19" style="min-height:81px;">
              <p class="problem"><span class="Q">Q:</span>
                {{data.title}}</p>
            </el-col>
          </el-row>
          <el-row v-for="(item, index) in data.replies" :key="index" style="border-top:1px solid #ccc;min-height:81px;">
            <el-col :xs="24" :sm="7" :md="5">
              <p class="expert">{{expertsReplyTitle}}</p>
              <p>{{item.updatedAt|dateFormat}}</p>
            </el-col>
            <el-col :xs="24" :sm="17" :md="19" style="border-left:1px solid #ccc;min-height:80px;">
              <p class="problem"><span class="Q">A:</span>
                {{item.content}}</p>
            </el-col>
          </el-row>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="replyCodeSub()" v-if="replyAnswer == 1">{{formInfo.btnSubmit}}</el-button>
        <el-button @click="viewReplyVisible = false" type="info" plain>{{formInfo.btnClose}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getMessageDetail } from '@/api/onlineMessage.js'
import { getCategory, getConsultationDetail } from '@/api/onlineConsultation.js'
import { getBusinessCooperationDetail } from '@/api/businessCooperation.js'
export default {
  data() {
    return {
      flag: '',
      viewReplyVisible: false,
      formInfo: {},
      form: {
        code: '',
      },
      rules: {
        code: [{ required: true, message: '请输入查询码', trigger: 'blur' }],
      },
      replyAnswer: 1,
      data: {},
      onlineConsultationList: [],
      expertsReplyTitle: '专家回复',
    }
  },
  methods: {
    open(flag, data) {
      this.formInfo = data
      this.flag = flag
      this.viewReplyVisible = true
      this.replyAnswer = 1
      this.expertsReplyTitle = data.expertsReplyTitle
    },
    replyCodeSub() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const url =
            Number(this.flag) === 1
              ? getMessageDetail(this.form.code)
              : Number(this.flag) === 2
              ? getConsultationDetail(this.form.code)
              : getBusinessCooperationDetail(this.form.code)
          url.then((res) => {
            this.data = res.data
            let arr = this.data.name
            this.data.name = arr.substring(0, 1) + new Array(arr.length).join('*')
            this.replyAnswer = 2
          })
        } else {
          return false
        }
        this.getCate()
      })
    },
    handleClose() {
      this.viewReplyVisible = false
    },
    // 获取类别
    async getCate() {
      await getCategory(this.$route.query.languageId).then((res) => {
        for (let i of res.data) {
          if (this.data.categoryId == i.id) {
            this.data.categoryName = i.name
          }
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.viewReply {
  button {
    padding: 12px 50px;
  }
  p {
    text-align: center;
    font-size: 24px;
    line-height: 36px;
    margin: 0;
  }
  .reply {
    color: #d11a2d;
  }
  .replyCodeForm {
    padding: 30px 0 0;
    /deep/.el-form-item__label {
      font-size: 18px;
    }
    /deep/.el-form-item {
      margin: 0;
    }
  }
  /deep/.el-dialog__footer {
    padding: 10px 20px 40px;
  }
  /deep/.el-dialog {
    width: 90%;
  }
  .QAMain {
    border: 1px solid #ccc;
    display: block;
    color: #666;
    margin-bottom: 20px;
    * {
      font-size: 14px;
    }
    p.problem {
      color: #333;
      text-align: left;
      line-height: 26px;
      padding: 0 20px;
    }
    .bg {
      background: #f7f7f7;
      min-height: 80px;
    }
    .title {
      background: #d11a2d;
      border-radius: 12px;
      padding: 0 15px;
      color: #fff;
      line-height: 22px;
      display: inline-block;
    }
    .Q {
      color: #d11a2d;
    }
    .expert {
      color: #333;
    }
  }
  @media (min-width: 768px) and (max-width: 992px) {
    /deep/.el-dialog {
      width: 70%;
    }
    .replyCodeForm {
      padding: 30px 10% 0;
    }
  }
  @media (min-width: 992px) {
    /deep/.el-dialog {
      width: 50%;
    }
    .replyCodeForm {
      padding: 30px 10% 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contactUs/components/viewReply.vue